// extracted by mini-css-extract-plugin
export default {"mobileResume":"styles_mobileResume__1uBiY","button":"styles_button__rk0jC","resume":"styles_resume__XypbH"};